import { properties } from '../shared/properties'

export default function getToken() {
    let baseUrl = properties.baseUrl
    let url = 'token'
    var raw = JSON.stringify({ "username": window.localStorage.getItem('username'), "password": window.localStorage.getItem('password') })
    var headers = new Headers();
    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: raw,
        redirect: 'follow'
    }
    return (
        fetch(baseUrl + url, requestOptions)
    )

}
